import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Grid, TextField, Typography } from "@mui/material";
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

interface AffiliateAccordionDetailProps {
    detail: any,
    isDisabled: boolean
}

const AffiliateAccordionDetail = ({ detail, isDisabled }: AffiliateAccordionDetailProps) => {
    const { t } = useTranslation(['salesmarketing', 'translation']);
    const { t :type } = useTranslation(['servicetype', 'translation']);

    return (
        <>
            <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
                    <Typography>{t('salesmarketing:affiliate.detailContent.generalInfoSummary')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1}>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.bpKindField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.bpKind && detail?.bpKind.split('|').length >1 ? detail?.bpKind.split('|')[1] : detail?.bpKind }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.namingField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.naming}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.serviceTypeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail.serviceType.length > 0 ? detail.serviceType.map((s:string)=> s.includes('|') ? type(s.split('|')[0].replace(":", "-"))  : s).join(', ') : ''}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.countryField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.country}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.regionField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.region &&detail?.region.split('|').length >1 ? detail?.region.split('|')[1] : detail?.region }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.provinceField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.province}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.cityField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.city}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.addressField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.address}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.streetNumberField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.streetNumber}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.postalCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.postalCode}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.areaField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.area && detail?.area.split('|').length >1 ? detail?.area.split('|')[1] : detail?.area }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.phoneNumberField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.phoneNumber}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.cellPhoneNumberField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.cellPhoneNumber}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.emailField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.email}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.iataCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.iataCode}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.websiteField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.website}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.incomeCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.incomeCode}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.percipientField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.percipient && detail?.percipient.split('|').length >1 ? detail?.percipient.split('|')[1] : detail?.percipient }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.percipientProvinceField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.percipientProvince}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.percipientCityField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.percipientCity}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.percipientAddressField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.percipientAddress}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.percipientPostalCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.percipientPostalCode}
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
                    <Typography>{t('salesmarketing:affiliate.detailContent.representativeInfoSummary')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1}>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.taxCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.taxCode}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.sdiCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.sdiCode}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeNameField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeName}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeEmailField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeEmail}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeCellphoneField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeCellphone}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeContactNameField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeContactName}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeContactEmailField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeContactEmail}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeContactCellphoneField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeContactCellphone}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeHqCellphoneField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeHqCellphone}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeIbanField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeIban}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeProvinceField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeProvince}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeCityField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeCity}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeAddressField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeAddress}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativeStreetNumberField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeStreetNumber}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativePostalCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativePostalCode}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:affiliate.detailContent.representativePecField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativePec}
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </>
    );
}

export default AffiliateAccordionDetail;


